// extracted by mini-css-extract-plugin
export default {"circle":"StaffPhotoPicker_circle__ZmbfV","overlay":"StaffPhotoPicker_overlay__WqSTE"};